import * as Yup from "yup"
import _ from "lodash"

export default function validation_staff_password(field, acc = {}, editMode) {
  const { field_name, field_validation } = field

  const isRequiredTxt =
    (field_validation && field_validation.required && field_validation.required[1]) ||
    "Required field."

  if (editMode) {
    return {
      [field_name]: Yup.string().when("staff__password_update", {
        is: (value) => {
          if (Array.isArray(value)) {
            return value.includes("Select to update password")
          }
          return value === "Select to update password"
        },
        then: Yup.string().min(6, "Password must be at least 6 characters long.").required(isRequiredTxt),
      }),
      ...acc,
    }
  }

  // fallback: ensure we always return an accumulator object (preserve original logic)
  return acc
}